/** @jsxImportSource @emotion/react */

import {
  Input,
  Modal,
  Typography,
  UtilityButton,
  useTheme,
} from '@quickbit/qb-design-system';
import { useEffect, useState } from 'react';
import { useStartDirectOnrampFlow } from 'api/useDirectOnrampApi';

interface Props {
  onCreate: () => void;
}

export const StartDirectOnrampFlow = ({ onCreate }: Props) => {
  const { spacing } = useTheme();
  const [modalOpen, setModalOpen] = useState(false);

  const [intervalTimeInput, setIntervalTimeInput] = useState<number>(1000);
  const [interval, setInterval] = useState<number>(0);

  const { data } = useStartDirectOnrampFlow(interval);

  useEffect(() => {
    onCreate();
  }, [data, onCreate]);

  return (
    <>
      <UtilityButton
        icon={interval > 0 ? 'spinner' : undefined}
        onClick={
          interval
            ? () => setInterval(0)
            : () => {
                setModalOpen(true);
              }
        }
        text={`${interval ? 'Stop ' : 'Start'} Direct Onramp Flow`}
      />
      {modalOpen && (
        <Modal
          title="Start Direct Onramp flow"
          primaryButtonProps={{
            onClick: () => {
              setInterval(intervalTimeInput);
              setModalOpen(false);
            },
            text: 'Start',
            disabled: !intervalTimeInput,
          }}
          secondaryButtonProps={{
            onClick: () => setModalOpen(false),
            text: 'Cancel',
          }}
          closeModal={() => setModalOpen(false)}
        >
          <div
            css={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gridTemplateRows: '1fr 1fr',
              alignItems: 'center',
              gap: spacing.xxs,
            }}
          >
            <>
              <Typography variant="bodyBold">Interval time</Typography>
              <Input
                type="number"
                value={String(intervalTimeInput)}
                onChange={(e) => setIntervalTimeInput(Number(e.target.value))}
                endAdornment="ms"
              />
            </>
          </div>
        </Modal>
      )}
    </>
  );
};
